export default __webpack_public_path__ + "static/media/renault.da222ad2.svg";